import React from "react";

const Bash_Tail = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Tail</h2>
      <p>Show the end of a file. Useful for logs.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>tail [options] [file]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>tail -n 50 /var/log/syslog
tail -f /var/log/app.log</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -f to follow appended data in real-time.</p>
    </div>
  );
};

export default Bash_Tail;
